
import { TransactionCategory } from "../../classes"

const TransactionCategoryModule = {
  namespaced: true,
  state: {
    transactionCategories: null
  },
  mutations: {
    setTransactionCategories(state, transactionCategories) {
      state.transactionCategories = transactionCategories
    },
    clearTransactionCategories: (state) => {
      state.transactionCategories = null
    },
  },
  actions: {
    getTransactionCategoryByProject: async ({ commit }, formData) => {
      try {
        commit('clearTransactionCategories')
        const data = await TransactionCategory.getTransactionCategoryByProject(formData);
        commit('setTransactionCategories', data)
        return data;
      } catch (error) {
        throw error;
      }
    },
    createTransactionCategory: async ({ commit }, formData) => {
      try {
        const data = await TransactionCategory.createTransactionCategory(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
    removeTransactionCategory: async ({ commit }, id) => {
      try {
        const data = await TransactionCategory.removeTransactionCategory(id);
        return data;
      } catch (error) {
        throw error;
      }
    },
    updateTransactionCategory: async ({ commit }, formData) => {
      try {
        const data = await TransactionCategory.updateTransactionCategory(formData);
        return data;
      } catch (error) {
        throw error;
      }
    },
  },
};
export default TransactionCategoryModule;
